import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { channels, siteMeta } from "@/mocks/chigua";

const navLinks = [
  { to: "/", label: "首页" },
  ...channels.map((c) => ({ to: `/list/${c.slug}`, label: c.name })),
  { to: "/about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [kw, setKw] = useState("");
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      {/* 顶部提示条 */}
      <div className="hidden bg-foreground-950 text-background-50 lg:block">
        <div className="mx-auto flex h-8 max-w-[1400px] items-center justify-between px-4 text-xs md:px-6">
          <p className="flex items-center gap-2 text-background-200">
            <i className="ri-flashlight-line text-secondary-400" aria-hidden="true" />
            {siteMeta.tagline}
          </p>
          <div className="flex items-center gap-5">
            <span className="flex items-center gap-1 text-background-300">
              <i className="ri-calendar-line" aria-hidden="true" />
              娱乐情报 · 每日更新
            </span>
            <a
              href={`mailto:${siteMeta.email}`}
              className="flex items-center gap-1 text-background-300 transition hover:text-secondary-300"
              rel="nofollow"
            >
              <i className="ri-mail-line" aria-hidden="true" />
              商务与投稿
            </a>
          </div>
        </div>
      </div>

      {/* 主栏 */}
      <div className="mx-auto flex h-16 max-w-[1400px] items-center justify-between gap-4 px-4 md:h-[72px] md:px-6">
        {/* 品牌 */}
        <Link to="/" className="flex shrink-0 items-center gap-2.5" aria-label={siteMeta.brand}>
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-primary-500 font-display-sc text-xl leading-none text-background-50 md:h-10 md:w-10">
            瓜
          </span>
          <span className="leading-tight">
            <span className="block font-display-sc text-xl text-foreground-950 md:text-2xl">
              {siteMeta.brand}
            </span>
            <span className="hidden text-[10px] tracking-[0.22em] text-foreground-500 sm:block">
              JINRI CHIGUA · 内幕深扒
            </span>
          </span>
        </Link>

        {/* 桌面导航 */}
        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-700 transition hover:bg-primary-100/70 hover:text-primary-700"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        {/* 右侧操作 */}
        <div className="flex items-center gap-2 md:gap-3">
          <div className="relative hidden xl:block">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" aria-hidden="true" />
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && kw.trim()) {
                  navigate(`/search?kw=${encodeURIComponent(kw.trim())}`);
                  setKw("");
                }
              }}
              placeholder="搜索圈内线索…"
              className="h-9 w-52 rounded-full border border-background-200 bg-background-100 pl-9 pr-3 text-sm text-foreground-800 outline-none transition focus:border-primary-400 focus:bg-background-50"
              aria-label="站内搜索"
            />
          </div>
          <Link
            to="/contact"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            线索投稿
          </Link>
          <button
            type="button"
            onClick={() => setOpen(!open)}
            className="grid h-10 w-10 place-items-center rounded-md border border-background-200 text-xl text-foreground-800 lg:hidden"
            aria-label="打开菜单"
            aria-expanded={open}
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-3 lg:hidden">
          <div className="relative mb-3 xl:hidden">
            <i className="ri-search-line pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-foreground-400" aria-hidden="true" />
            <input
              value={kw}
              onChange={(e) => setKw(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter" && kw.trim()) {
                  navigate(`/search?kw=${encodeURIComponent(kw.trim())}`);
                  setKw("");
                  setOpen(false);
                }
              }}
              placeholder="搜索圈内线索…"
              className="h-10 w-full rounded-full border border-background-200 bg-background-100 pl-9 pr-3 text-sm outline-none focus:border-primary-400"
              aria-label="站内搜索"
            />
          </div>
          <nav className="flex flex-col" aria-label="移动端导航">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between border-b border-background-100 py-3 text-[15px] font-medium text-foreground-800"
              >
                {l.label}
                <i className="ri-arrow-right-s-line text-foreground-400" aria-hidden="true" />
              </Link>
            ))}
            <Link
              to="/contact"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex justify-center whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-medium text-background-50"
            >
              线索投稿
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}